/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_CompletedInputs */

const en_common_completed = /** @type {(inputs: Common_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completed`)
};

const es_common_completed = /** @type {(inputs: Common_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completado`)
};

/**
* | output |
* | --- |
* | "Completed" |
*
* @param {Common_CompletedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_completed = /** @type {((inputs?: Common_CompletedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_CompletedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_completed(inputs)
	return en_common_completed(inputs)
});